export const GET_ALL_BLOGS = "GET_ALL_BLOGS";
export const LOGIN_USER = "LOGIN_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const SIGN_UP_USER = "SIGN_UP_USER";
export const SAVE_BLOG = "SAVE_BLOG";
export const GET_BLOG_DETAILS = "GET_BLOG_DETAILS";
export const SAVE_POST = "SAVE_POST";
export const UP_VOTE = "UP_VOTE";
export const DOWN_VOTE = "DOWN_VOTE";
export const SAVE_POST_TITLE = "SAVE_POST_TITLE";
export const GET_POST_DETAILS = "GET_POST_DETAILS";
export const GET_RECENT_POSTS = "GET_RECENT_POSTS";
export const GET_USER = "GET_USER";